import React, { FunctionComponent } from "react";
import { NodeProps } from "reactflow";
import { BasicNodeLayout, DocumentSchemaSource, NodeSize, NodeType, NodeTypeCategory } from "../Base";
import { NodeConfigPropertyType } from "../../FlowDocument/PropertyTypeDefinitions";
import { DataType } from "../TypeDefinitions";
import { eventHeadersName, eventPayloadName } from "../SchemaSystem";

const event = "Event Trigger";
const eventTopicId = "eventTopicId";
const eventNameProperty = "eventTopicName";
const payloadLabel = "Data";
const eventCreated = "eventCreated";

globalThis.nodeTypeDefinitions.setDefinition({
  nodeType: NodeType.eventTrigger,
  category: NodeTypeCategory.general,
  label: event,
  featureToggle: "feat-core-3217-show-event-trigger",
  controlOutputOnly: true, // removes control input handle
  controlOutputs: [{ name: "triggered" }],
  dataInputs: [],
  dataOutputs: [
    { name: eventPayloadName, type: DataType.OBJECT, label: payloadLabel },
    { name: eventHeadersName, type: DataType.OBJECT, enabled: false }
  ],

  nodeConfigProperties: [
    {
      name: eventTopicId,
      label: event,
      propertyType: NodeConfigPropertyType.Event,
      schemaSourceSystemType: DocumentSchemaSource.plexEvent,
      schemaSystem: { createIo: true },
      options: { setFlowInputsFromSchemas: true }
    },
    {
      name: eventNameProperty,
      propertyType: NodeConfigPropertyType.NoInput // no input because a picker always decides the value
    },
    {
      name: "outputs",
      sectionName: "Output",
      propertyType: NodeConfigPropertyType.EnabledOutputs
    },
    {
      name: "flowPayloadDataEditor",
      label: "",
      sectionName: "Test Data",
      propertyType: NodeConfigPropertyType.FlowInputDataEditor,
      options: { inputSubName: eventPayloadName, label: payloadLabel, excludedProperties: [] }
    },
    {
      name: "flowHeaderDataEditor",
      sectionName: "Test Data",
      label: "",
      propertyType: NodeConfigPropertyType.FlowInputDataEditor,
      options: {
        inputSubName: eventHeadersName,
        excludedProperties: [eventCreated],
        applyOverrides: (_, flowInput) => {
          flowInput[eventCreated] = new Date().toISOString();
        }
      }
    }
  ],
  size: NodeSize.Small,
  skipEvaluate: true,
  evaluate: () => {
    return { output: {}, activeControlHandleIds: [] };
  }
});

export const EventTriggerNode: FunctionComponent<NodeProps> = ({ id, data }) => {
  const label = data.nodeProperties[eventNameProperty] ?? event;
  data.nodeProperties.label = label;
  return <BasicNodeLayout id={id} data={data} label={label} />;
};
